// /account/login — Shopify Customer Account OAuth sign-in surface.
//
// Note on the iframe: earlier drafts embedded the OAuth authorize URL in an
// <iframe>. Shopify's hosted authorize page ships `X-Frame-Options: DENY`
// and `Content-Security-Policy: frame-ancestors 'none'`, so every browser
// refuses to render it inside our page ("refused to connect"). Top-level
// navigation is the only viable path — the CTA below does exactly that.

import { ACCOUNT } from '../../constants/testIds';
import { API_BASE } from '../../lib/apiBase';

const BACKEND = API_BASE;
const RETURN_PATH = '/account/index';

export default function AccountLogin() {
        const startUrl = `${BACKEND}/api/account/oauth/start?return_path=${encodeURIComponent(RETURN_PATH)}`;
        return (
                <main
                        data-testid={ACCOUNT.loginPage}
                        className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6 py-16"
                >
                        <div className="w-full max-w-[520px] border border-white/15 bg-black">
                                <div className="border-b border-white/10 px-6 py-6">
                                        <p className="font-mono text-[11px] tracking-[0.18em] text-[#FF9F1C]">
                                                LOADOUT / ACCOUNT
                                        </p>
                                        <h1 className="mt-2 font-display text-[32px] leading-tight uppercase">
                                                Sign in
                                        </h1>
                                        <p className="mt-3 font-sans text-[13px] text-white/60 leading-relaxed">
                                                We use your Loadout Customer Account. You’ll be
                                                redirected to the Shopify-hosted sign-in page — new
                                                operators get a create-account link on the way in.
                                        </p>
                                </div>

                                <div className="px-6 py-6 space-y-4">
                                        <a
                                                href={startUrl}
                                                data-testid={ACCOUNT.loginPrimaryCta}
                                                className="block w-full text-center border border-[#FF9F1C] bg-[#FF9F1C] text-[#0A0A0A] font-mono text-[12px] tracking-[0.2em] uppercase py-3.5 hover:bg-transparent hover:text-[#FF9F1C] transition-colors"
                                        >
                                                Continue with Shopify →
                                        </a>
                                </div>
                        </div>
                </main>
        );
}
